import { render, staticRenderFns } from "./detailMaterialMaster.vue?vue&type=template&id=5a0a91af&scoped=true&"
import script from "./detailMaterialMaster.vue?vue&type=script&lang=js&"
export * from "./detailMaterialMaster.vue?vue&type=script&lang=js&"
import style0 from "./detailMaterialMaster.vue?vue&type=style&index=0&id=5a0a91af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a91af",
  null
  
)

export default component.exports